package com.parmartechnologies.core.feature.order.reason

enum class OrderReason {
    INVENTORY_ISSUE,
    DELIVERY_ISSUE,
    OTHER
}